/** Legacy suffix stored on paired smart groups before the product rename. */
export const LEGACY_SMART_GROUP_NAME_SUFFIX = ' (auto-filled)';

export const displaySmartGroupName = (name: string): string =>
  name.endsWith(LEGACY_SMART_GROUP_NAME_SUFFIX)
    ? name.slice(0, -LEGACY_SMART_GROUP_NAME_SUFFIX.length)
    : name;

export const displayGroupName = (row: {
  name: string;
  type: 'manual' | 'template';
}): string => (row.type === 'template' ? displaySmartGroupName(row.name) : row.name);
